export interface PromotionServiceConfig {
	baseUrl: string;
}

export function loadPromotionServiceConfig(): PromotionServiceConfig {
	const { PROMOTION_SERVICE } = process.env;

	if (!PROMOTION_SERVICE) {
		throw new Error("PROMOTION_SERVICE config is not set.");
	}

	return {
		baseUrl: PROMOTION_SERVICE
	};
}
